import { ReactNode, useState } from 'react';
import { Button } from '@platform/components';

type ExampleResponseProps = {
  children: ReactNode;
  label?: string;
};

export const ExampleResponse = ({ children, label = 'Example response' }: ExampleResponseProps) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div>
      <Button
        additionalClassnames='flex cursor-pointer items-center gap-1.5 outline-none'
        onPress={() => setIsOpen((prev) => !prev)}
        size='md'
        variant='link-color'
        leadIcon='lightbulb-02'
        leadIconClassNames='stroke-brand-500'
        tailIcon={isOpen ? 'chevron-up' : 'chevron-down'}
        tailIconClassNames='stroke-brand-500'
      >
        {label}
      </Button>
      {isOpen && (
        <div className='mt-2 rounded-lg border border-gray-100 bg-gray-50 px-4 py-4 text-sm font-normal leading-5 text-gray-700'>
          {children}
        </div>
      )}
    </div>
  );
};
